import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { TicketAnswerRequestModel } from '@/modules/ticket-answer/models/ticket-answer-request.model'
import { AdminTicketAnswerService } from '@/modules/ticket-answer/services/admin-ticket-answer.service'
import { TicketStoreRequestModel } from '@/modules/ticket/models/ticket-request.model'

@vservice()
export class TicketAnswerUpdateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminTicketAnswerService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(ticketId: number, answerId: number, data: TicketStoreRequestModel) {
    const request: TicketAnswerRequestModel = {
      files: this.fileFilter(data.file),
      message: data.message
    }
    return this.service.update(ticketId, answerId, request)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  fileFilter(array) {
    return array.filter(item => item instanceof File)
  }

}
